
let lang = {
  isChina: 2,
  home: 'Home',
  kczx: 'Course',
  xzapp: 'Download APP',
  xxdt: 'Learning',
  appTip: 'Tips: please use the browser to scan the code of android app. After installing [E-class online school] app, please search and select the current online school name before entering.',
  xsapp: "APP in user's end",
  downloadTip: 'More convenient and more efficient to learn',
  android: 'Android App',
  ios: 'Apple App',
  browser: 'Browser download',
  browserTip: 'Please use the following browsers recommended to make your stable experince',
  google: 'Google',
  firefox: 'Firefox',
  browser360: '360',
  browserqq: 'QQ',
  lxkf: 'Contact customer service',
  help: 'Help',
  kczxun: 'Service',
  hddb: 'Top',
  kfdh: 'Phone: ',
  kfqq: 'QQ: ',
  nohelp: 'There are currently no help documents',
  exit: 'Exit login?',
  tips: 'Tips',
  define: 'Define',
  cancel: 'Cancel',
  my_course: 'My course',
  grzl: 'Personal data',
  safe_exit: 'Exit',
  login: 'Sign in',
  reg: 'Sign up',
  sign_up: 'Sign up',
  logining: 'Logging in',
  account_login: 'account login',
  code_login: 'Code login',
  remember: 'Remember the account',
  retrieve: 'Retrieve password',
  msg_sent: 'The message has been sent, please check',
  msg_sent1: 'The verification code has been sent to your mobile, please check',
  msg_sent2: 'The verification code has been sent to your email, please check',
  get_code: 'Send Verify Code',
  apply_again: 'apply again',
  account_tip: 'You have already registered your account. Do you want to log in',
  input_num: 'Input phone number',
  check_num: 'The phone number format is incorrect, please check',
  check_num1: 'The phone number or email format is incorrect, please check',
  enter_code: 'Please enter verification code',
  type_characters: 'Code',
  account: 'Your Email Adress or Phone Number',
  password: 'Please enter Password',
  enter_password: 'Please enter password',
  correct_password: 'Please enter the correct password',
  submit: 'Submit',
  phone: 'Phone',
  phone_email: 'Your Email Adress or Phone Number',
  phone_email_tip: 'Please enter your registration email or mobile number in Chinese Mainland',
  bind_phone: 'Bind account',
  code: 'verification code',
  tobind: 'You have already registered your account. Do you want to bind',
  agreement: 'read and agree to the agreement, privacy terms and child privacy agreement',
  read_agree: 'read and agree to the',
  user_agreement: ' agreement',
  privacy_terms: 'privacy terms',
  child_agreement: 'child privacy agreement',
  noreg: "You haven't registered yet. Do you want to register now",
  graphical_code: 'Please enter the graphical verification code',
  noclearly: "can't see clearly",
  change_one: 'change another one',
  passwords: '8-20 alphanumeric passwords',
  passwordsTip: '8-20 digits, including any two combinations of numbers, letters, and symbols',
  log_now: 'Existing account? Log in now',
  have_account: 'You have already registered your account. Do you want to log in now',
  center_address: 'Experience Center Address:',
  hotline: 'Service hotline:',
  forgot_password: 'Forgot password',
  new_password: 'new password',
  enter_new_password: 'Please enter a new password',
  nouser: 'User does not exist',
  password_reset: 'Password reset complete',
  recommend: 'Recommend',
  all_recommended: 'All recommended',
  enter_interested: 'Content Search',
  search: 'Search',
  nologging: 'Log in for more essay',
  log_in_now: 'log in now',
  my_favorite: 'my favorite',
  my_collection: 'my collection',
  like: 'Like',
  liked: 'Liked',
  collect: 'Collect',
  collected: 'Collected',
  no_data: 'No data',
  no_course: 'No courses now',
  wszl: 'complete the materials to let your teacher know you better ~',
  nick_name: 'Nick name',
  birthday: 'Birthday',
  select_date: 'Select date',
  time_zone: 'Time zone',
  complete_later: 'Complete later',
  save_data: 'Save data',
  city: 'City',
  live_class: 'Live class',
  learn_anytime: 'Pick-learning',
  city_tip: 'please select your city',
  time_zone_tip: 'please select your time zone',
  birthday_tip: 'please select your birthday',
  nick_name_tip: 'please fill in your nickname',
  unread: 'There are unread messages in your website, click to check!',
  enter_course: 'Please enter the course name to search',
  choose_class: 'Please choose a free class',
  saved: 'saved',
  confirm_time_zone: 'Confirm time zone notification',
  confirm_time_zone_data: 'Hello, your default time zone is BeiJing (UTC+08:00). In order to improve your class experience, please click the button below to confirm or modify the time zone.',
  go_modify: 'Go to modify',
  your_grade: 'your grade',
  select_grade: 'select grade',
  choose_course: 'Please choose a course',
  new_comers: 'benifit for new comers only',
  free_class: 'congratulations for 1 free class',
  next_time: 'Next time',
  get_it_now: 'Get it now',
  interested_courses: 'what courses are you interested in?',
  next: 'next',
  save: 'save',
  free_lessons: "Here's our recommendation of free lessons for you.",
  change_batch: 'Change batch',
  free: 'free',
  no_accessed: "current subject can't be accessed.",
  step: 'Please return to the previous step',
  no_need: 'no need, thanks',
  gift: 'Receive a gift',
  received_succeed: 'Received successfully',
  invite: 'Invite friends to get more free lessons',
  click_more: 'click for more',
  all: 'All',
  mon_fri: 'Mon to Fri',
  sat: 'Sat',
  sun: 'Sun',
  in_progress: 'In progress',
  ended: 'Ended',
  full: 'Applications is full',
  discontinued: 'Discontinued',
  stop_selling: 'Stop selling',
  no_started: 'Not started',
  subject: 'Subject: ',
  time: 'Time: ',
  type: 'Type: ',
  state: 'State: ',
  unlock_time: 'Unlock time: ',
  lecturer: 'Lecturer: ',
  comments: 'Comments',
  star: 'star',
  cpbm: 'registrater after evaluation',
  ljbm: 'Register now',
  purchased: 'Purchased',
  fdgm: 'Buy in segments',
  yfdgm: 'Segmented purchase',
  course_introduction: 'Course introduction',
  chapter_list: 'Chapter list',
  comment: 'Comment',
  course_evaluation: 'course evaluation',
  take_course: 'How to take course',
  chapter_list_tip: 'You can watch the playback after you sign up for the course finished.',
  take_course_tit1: '1.Course selection',
  take_course_tit2: '2.Download browser',
  take_course_tit3: '3.Attend class',
  take_course_tit4: '4.Complete the exercise',
  take_course_con1: 'Choose  interested courses on the web or app',
  take_course_con2: 'Download the browser to prepare for class',
  take_course_con3: 'Enter the classroom 15 minutes early before class, and you can watch the video replay repeatedly after class',
  take_course_con4: 'Remember to finish the exercises after class, the lecturer will explain the wrong question in the next class',
  go_download: 'Go download',
  course_details: 'Course details',
  no_course_sale: 'has no courses on sale for the time being',
  grade1: 'grade: ',
  education: 'education: ',
  teaching_age: 'teaching age: ',
  lecturer_profile: 'Lecturer Profile',
  course_purchase: 'Course purchase',
  buy_fdgm: 'Order information (full course purchase)',
  buy_qkgm: 'Order information (buy in stages)',
  existing_course: 'existing course',
  purchase_courses: 'purchase courses',
  see_more: 'see more',
  buy_tip1: 'Please read the',
  buy_tip2: '"Course Purchase Statement"',
  buy_tip3: 'to understand the rules before purchasing',
  confirm_purchase: 'confirm purchase',
  read_agreement: 'I have read and understand the agreement',
  think_about_it: 'think about it',
  following_courses: 'Do you really want to purchase the following courses: ',
  need_to_pay: 'need to pay',
  discount: 'discount: ',
  original_price: 'original price: ',
  lbls: 'tuition will be reduced immediately for consecutive registrations',
  more_lb: 'More discounts for consecutive registrations',
  buy_now: 'buy now',
  yhlb: 'consecutive registrations',
  current_price: 'current price: ',
  evaluation: 'Evaluation',
  full_score: 'full score',
  points: 'points',
  dtsj: 'The time allotted for this test',
  minute: 'minute',
  start_ass: 'Start the assessment',
  overall_score: 'Overall score',
  cpts: 'Number of assessment questions',
  question: 'Question',
  options: 'Options',
  correct: 'Correct',
  wrong: 'Wrong',
  unanswered: 'unanswered',
  answered: 'answered',
  submit_answer: 'submit answer',
  time_remain: 'Time remaining: ',
  unfinished: 'You have unfinished questions',
  re_do: 're-do the exercise',
  head_purchase: 'head to purchase',
  back_course: 'Back to Course List',
  student: 'Student',
  unbuy1: 'your score < ',
  unbuy2: ' points, you cannot apply for this course,please choose other courses',
  can_buy1: 'your score >= ',
  can_buy2: 'points, you can apply for this course',
  assessment_results: 'assessment results',
  assessment_score: 'score',
  correct_rate: 'correct rate',
  time_use: 'time use',
  msg_center: 'Message Center',
  system_info: 'System information',
  feedback: 'Feedback',
  provide_feedback: 'Provide feedback and advice',
  msg_read: 'Mark all the messages as read',
  title: 'Title',
  states: 'States',
  sand_time: 'The time of sending',
  have_read: 'Have read',
  un_read: 'Unread',
  your_opinion: 'Your opinion is the biggest driving force for us to move forward, I sincerely thank you for your cooperation and support.',
  all_read: 'Are you sure to make all unread messages marked as read?',
  send_it: 'Are you sure to send it?',
  thank_feedback: 'Thank you for your feedback and suggestions, we will deal with it in time!',
  details: 'details',
  reply: 'reply',
  incomplete: 'Exercises',
  all_reviews: 'View all reviews',
  exercises_no_finish: 'There are currently no exercises that need to finish',
  submitted_pass: 'Submitted time has passed',
  practice_grated: 'You can do the practice test but the test will not be grated',
  complete_exercise: 'Complete the exercise',
  deadline_submit: 'Deadline for submission: ',
  related_exercises: 'Related exercises',
  curriculum: 'Curriculum list',
  search_courses: 'Search for courses',
  eva_tip: 'Please complete the exercise in time',
  eva_tip1: ', end date: ',
  eva_tip2: 'The lecturer will explain the wrong questions  in the next lesson, please complete them carefully',
  exam_analysis: 'Exam question analysis: ',
  find_reason: "Didn't do well on the test? Please find out the reason",
  score: 'score',
  view_all: 'view all',
  collapse_content: 'Collapse content',
  time_submission: 'The time of submission',
  lec_correction: "Lecturer's correction",
  attachment: 'attachment: ',
  answer_question: 'Answer question',
  word: 'word',
  picture: 'picture',
  recording: 'recording',
  video: 'video',
  audio: 'audio',
  document: 'document',
  remove_document: 'remove document',
  enter_text: 'Please enter text',
  start: 'start',
  pause: 'pause',
  continute: 'continute',
  stop: 'stop',
  del_record: 'Are you sure you want to delete the recording',
  del: 'delete',
  success_del: 'successfully deleted!',
  page_microphone: 'Please allow this page to use the microphone first',
  img9: 'You can upload up to 9 images!',
  img_type: 'Only jpg, png and other formats can be uploaded!',
  mb3: 'Please upload a file no larger than 3MB!',
  mp4: 'Only allow upload mp4 files!',
  mb100: 'File size is not allowed to exceed 100MB!',
  video_uploading: 'Your video is uploading',
  video_success: 'Uploaded video successfully!',
  img_success: 'Image upload successfully!',
  mp3: 'Only upload in mp3 format!',
  mb30: 'The upload audio size cannot exceed 30M!',
  document_success: 'Document uploaded successfully!',
  remove_doc: 'Do you really want to remove the document: ',
  remove: 'remove',
  unsubmission: 'You still have questions that have not been completed, do you want to finish them? You can not modify anything after submission.',
  continue_answer: 'continue to answer',
  pay_type: 'payment method',
  pay: 'pay',
  qr_code: 'Please pay after scanning QR code',
  give_up: 'Abandon purchase',
  repayments: 'Repayments',
  pay_success: 'You have paid successfully',
  purchased_course: 'Courses',
  schedule: 'Schedule',
  waiting: 'Waiting',
  completed: 'Completed',
  check_the_details: 'Check the details',
  no_course_tips: "You don't have any courses yet",
  next_class: 'Next class:',
  consult_lecturer: 'Consult lecturer',
  enter_the_classroom: 'Enter the class',
  playback: 'Playback',
  practice: 'Practice',
  broadcasting: 'Broadcasting',
  announcement_details: 'Announcement Details',
  slides_information: 'Slides information',
  course_practice: 'Course practice',
  view_my_comments: 'View my comments',
  watch_the_video: 'Watch the video',
  enter_tips: 'Enter the classroom 15 minutes early before class',
  not_yet_started: 'Not yet started',
  watch_the_course: 'Watch the course',
  watch_again: 'Watch again',
  unlock_tips: 'Complete the previous lesson to unlock',
  scoring: 'Scoring',
  attitude: 'Attitude',
  atmosphere: 'Atmosphere',
  contents: 'Contents',
  connection: 'Connection',
  scoring_tips: 'Your opinion is the biggest driving force for us to move forward, and I would like to express my sincere thanks for your cooperation and support.',
  course_briefing: 'Course briefing',
  chrome_tips1: 'In order to ensure the stability of the class, you need to use the Google or Firefox browser for the class. Other browsers may affect the effect of the class.',
  download_browser: 'Download browser',
  chrome_tips2: 'We do not support Windows XP, MAC OS 10.11 and other versions below, if the version is too low, please upgrade before class.',
  cannot_submit_repeatedly: 'Cannot submit repeatedly',
  comment_successful: 'Comment successful',
  not_over: 'In progress',
  study_group: 'Study group',
  group_tips1: 'Join class groups for',
  group_tips2: 'more efficient learning',
  study_report: 'study report',
  course_completion_rate: 'Course completion rate',
  practice_completion_rate: 'Practice completion rate',
  report_tips: 'The scores you get in the after-school practice of each class are shown in the figure. As you study, is the accuracy getting higher and higher?',
  report_charts_tips: 'X horizontal axis = course   Y vertical axis = Correct rate',
  chapter_name: 'Chapter name',
  status: 'Status',
  courseware: 'Courseware',
  operate: 'Operate',
  class_time: 'Class time',
  not_started: 'Not started',
  not_watched: 'Not watched',
  watched: 'Watched',
  file_preview: 'File preview',
  preview_courseware: 'Preview',
  personal_information: 'Personal Data',
  basic_information: 'Basic information',
  security_information: 'Security Information',
  gender: 'Gender',
  grade: 'Grade',
  revise: 'Revise',
  go_to_bind: 'Go to bind',
  unbind: 'Unbind',
  wechat: 'Wechat',
  female: 'Female',
  male: 'Male',
  select_your_grade: 'Select your grade',
  uploading: 'Uploading',
  change_password: 'Change password',
  verify_original_password: 'Verify original password',
  modify_phone_number: 'Modify phone number',
  verify_the_original_phone_number: 'Verify the original phone number',
  enter_the_new_phone_number: 'Enter the new phone number',
  new_phone_code: 'Enter the new phone verification code',
  new_password_tips: 'Please fill in a new password',
  same_password_tips: 'The new password cannot be the same as the old password',
  new_phone_tips: 'Please fill in the new phone number',
  original_password_tips: 'Please fill in the original password',
  please_enter_your_name: 'Please enter your nick name',
  nick_name_limit: '1-15 Chinese characters, numbers, upper and lower case letters, and underscores',
  complete_the_exercise: 'Complete the exercise',
  view_playback: 'View playback',
  please_select_city: 'Please select city',
  img_upload_type_tips: 'The uploaded image can only be in JPG format or PNG format!',
  img_upload_size_tips: 'The size of the uploaded image cannot exceed 3MB!',
  order_details: 'Order details',
  course_order: 'Course order',
  group_chase_order: 'Group chase order',
  product_name: 'Product name',
  selling_price: 'Selling price',
  payment_time: 'Payment time',
  order_status: 'Order status',
  paid: 'Paid',
  unpaid: 'Unpaid',
  cancelled: 'Cancelled',
  deleted: 'Deleted',
  to_pay: 'To pay',
  order_generation_time: 'Order generation time',
  pay_scan_tips: 'Please pay after scanning QR code',
  payment_failed: 'Payment failed',
  pay_fail_tips: 'You can choose to pay again or give up the purchase.',
  abandon_purchase: 'Abandon purchase',
  payment_method: 'Payment method',
  choose_payment_method: 'Choose payment method:',
  alipay: 'Alipay',
  exchange_center: 'Exchange Center',
  redemption_enter_tips: 'Please enter redemption code',
  exchange: 'Exchange',
  exchange_success_tips: 'The following courses have been added to your purchased courses',
  course_name: 'Course name',
  check_courses: 'Check courses',
  continue_to_redeem: 'Continue to redeem',
  redemption_code_limit: 'Only enter 12-digit exchange code.',
  return: 'Return',
  no_file_tips: 'The file address is missing.',
  license_post: 'Lecturer qualification',
  about_us: 'About us',
  copyright: 'Copyright ownership: ',
  technical: 'Technical support provided by KeyClass',
  information_public: 'Lecturer qualification',
  teacher_qualification: 'Teaching license',
  professional_qualification: 'Professional certificate',
  professional_level: 'Professional level certification',
  prev: 'Previous page',
  next_page: 'Next page',
  teaching_license: 'teaching license',
  qualification_certificate: 'Professional qualification certificate',
  level_certificate: 'Professional level certificate',
  no_certificate: 'No public qualification certificate',
  no_more_data: 'no more data!',
  contact_us: 'Contact us',
  no_file_permission_tips: 'You cannot view the courseware.',
  self_test: 'Device-Test',
  start_test: 'Start test',
  all_course: 'All courses',
  course_status: 'Status',
  course_subject: 'Subject',
  not_finished: 'Not finished',
  have_finished: 'Completed',
  course_introduce: 'Course Introduce',
  international_adult_edition: 'International Adult Edition',
  international_youth_edition: 'International Youth Edition',
  chinese_enhanced_edition: 'Chinese Enhanced Edition',
  special_training_edition: 'Special Training Edition',
  cultural_interest_edition: 'Cultural Interest Edition',
  teaching_research_faculty: 'Teaching and Research',
  to_learn: 'To learn',
  been_reg: '(This course has been registered)',
  registered: 'Registered',
  no_course_sale1: 'No courses for sale at the moment',
  no_tea_info: 'No lecturer introduction',
  tea_info: 'Lecturer introduction',
  course_sale: 'On sale course',
  tea_info1: 'Lecturer Profile',
  deliveryAddress: 'Receiving address',
  edit: 'Edit',
  addressReminder: 'Please enter your shipping address~',
  addressDetailLab: 'No shipping address',
  order_addressDetailLab: 'Please contact',
  editAddress: 'Edit Receiving address',
  addAddress: 'Add Receiving address',
  saveReminder: 'Your page information has not been saved,are you sure to return?',
  consignee: 'Consignee',
  location: 'Location',
  detailedAddress: 'Receiving Address',
  defaultShippingAddress: 'Set as default address',
  saveAddress: 'Save address',
  pleaseSelectRegion: 'Please select a region',
  enterRecipient: 'Please enter the recipient',
  enterMobileNumber: 'Please enter your mobile number',
  enterRegion: 'Please enter your region',
  enterDetailedAddress: 'Please enter the detailed address',
  enterCorrectMobileNumber: 'Please enter the correct mobile number',
  userNameNumError: 'The user name cannot exceed 16 characters. Please modify it and try again',
  addressError: 'The address cannot exceed 200 words. Please modify it and try again',
  savingSucceeded: 'Saving succeeded',
  bottomBtn: '+Add receiving address',
  deletAddressTitle: 'Delete',
  deletAddressMessage: 'Do you want to delete the address',
  operationSucceeded: 'Operation succeeded',
  purchaseCourse: 'Purchase a course',
  setDefault: 'Set as Default',
  defaultAddress: 'Default address',
  selectShippingAddress: 'Select shipping address',
  selectAnotherAddress: 'Select another address',
  trial: 'Free trial',
  free_trial: 'Free trial',
  log_in: 'Please log in first',
  watch: 'watch'
}
export default lang



// WEBPACK FOOTER //
// ./src/global/enLang.js